export const ERROR_KEYS_MAP: Record<
  FeederUrlConfig['key'],
  WSConnectionErrors
> = {
  liveV2: 'MARKET_V2_FEEDER',
  portfolioV2: 'PORTFOLIO_V2_FEEDER',
};

export const WS_STATUS = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

export const RECONNECTION_DELAY = 5000;

export const RECONNECTION_TIME_INTERVAL = 5000;

export const PING_MAX_COUNT = 4;
